import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthenService} from "./authen.service";
import {map} from "rxjs/operators";
import {OFFICER_AUTHORITIES} from "./_app_constant";

@Injectable({
  providedIn: 'root'
})
export class OfficerGuard implements CanActivate {

  constructor(private _authenService: AuthenService,
              private _router: Router) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this._authenService.auth$
      .pipe(
        map(auth => {
          if (!!this._authenService.hasAnyAuthority(auth.user, OFFICER_AUTHORITIES)) {
            return true;
          } else {
            this._router.navigate(['403']);
            return false;
          }
        })
      );
  }

}
